import React, { Component } from 'react';

class CaliberAddModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			newCaliber: '',
			error: ''
		};
	}

	handleNameChange = (e) => {
		this.setState({
			newCaliber: e.target.value,
			error: ''
		});
	}

	handleSave = () => {
		if (!this.state.newCaliber.trim()) {
			this.setState({ error: 'Please enter a caliber name' });
			return;
		}
		this.props.onSave(this.state.newCaliber);
		this.setState({ newCaliber: '' });
		this.props.onClose();
	}

	render() {
		const { onClose } = this.props;
		const { newCaliber, error } = this.state;

		return (
			<div style={styles.modalOverlay}>
				<div style={styles.modalContent}>
					<h2 style={styles.heading}>Add New Caliber</h2>

					<div style={styles.inputGroup}>
						<label htmlFor="caliberName" style={styles.label}>
							Caliber Name:
						</label>
						<input
							id="caliberName"
							type="text"
							value={newCaliber}
							onChange={this.handleNameChange}
							style={styles.inputField}
							autoFocus
						/>
						{error && <p style={styles.errorText}>{error}</p>}
					</div>

					<div style={styles.buttonGroup}>
						<button
							style={styles.cancelButton}
							onClick={onClose}
						>
							Cancel
						</button>
						<button
							style={styles.saveButton}
							onClick={this.handleSave}
						>
							Save
						</button>
					</div>
				</div>
			</div>
		);
	}
}

const styles = {
	modalOverlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		zIndex: 1000,
	},
	modalContent: {
		backgroundColor: 'white',
		padding: '25px',
		borderRadius: '8px',
		width: '400px',
		boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
	},
	heading: {
		fontSize: '24px',
		fontWeight: '600',
		marginTop: 0,
		marginBottom: '20px',
		color: '#333',
		borderBottom: '1px solid #eee',
		paddingBottom: '10px',
	},
	inputGroup: {
		marginBottom: '25px',
	},
	label: {
		display: 'block',
		marginBottom: '8px',
		fontWeight: '500',
		color: '#555',
		fontSize: '16px',
	},
	inputField: {
		width: '100%',
		padding: '10px 12px',
		border: '1px solid #ddd',
		borderRadius: '4px',
		fontSize: '16px',
		boxSizing: 'border-box',
		transition: 'border-color 0.2s ease',
		outline: 'none',
	},
	buttonGroup: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: '12px',
	},
	cancelButton: {
		padding: '10px 18px',
		backgroundColor: '#f1f1f1',
		color: '#333',
		border: 'none',
		borderRadius: '4px',
		cursor: 'pointer',
		fontWeight: '500',
		transition: 'background-color 0.2s ease',
	},
	saveButton: {
		padding: '10px 18px',
		backgroundColor: '#007bff',
		color: 'white',
		border: 'none',
		borderRadius: '4px',
		cursor: 'pointer',
		fontWeight: '500',
		transition: 'background-color 0.2s ease',
	},
	errorText: {
		color: '#dc3545',
		margin: '8px 0 0 0',
		fontSize: '14px',
		fontWeight: '500',
	},
};

export default CaliberAddModal;